// mutations
const RESTAURANT_PRODUCTS_CATEGORIES_ALL = (state, restaurantProductsCategories) => {
  if (restaurantProductsCategories.code === 1) {
    state.restaurantProductsCategories = restaurantProductsCategories.data
    state.status = 'success'
  } else {
    alert(restaurantProductsCategories.message)
    state.status = 'error'
  }
}

const RESTAURANT_PRODUCTS_CATEGORIES_FORM = (state, restaurantProductsCategories) => {
  if (restaurantProductsCategories.code === 1) {
    state.restaurantProductsCategories = restaurantProductsCategories.data
    state.status = 'success'
  } else {
    alert(restaurantProductsCategories.message)
    state.status = 'error'
  }
}

const RESTAURANT_PRODUCTS_CATEGORIES_SHOW = (state, restaurantProductsCategories) => {
  if (restaurantProductsCategories.code === 1) {
    state.restaurantProductsCategories = restaurantProductsCategories.data
    state.status = 'success'
  } else {
    alert(restaurantProductsCategories.message)
    state.status = 'error'
  }
}

const RESTAURANT_PRODUCTS_CATEGORIES_CREATE = (state, restaurantProductsCategories) => {
  if (restaurantProductsCategories.code === 1) {
    state.restaurantProductsCategories = restaurantProductsCategories.data
    state.status = 'success'
    alert(restaurantProductsCategories.message)
  } else {
    alert(restaurantProductsCategories.message)
    state.status = 'error'
  }
}

const RESTAURANT_PRODUCTS_CATEGORIES_UPDATE = (state, restaurantProductsCategories) => {
  if (restaurantProductsCategories.code === 1) {
    state.restaurantProductsCategories = restaurantProductsCategories.data
    state.status = 'success'
    alert(restaurantProductsCategories.message)
  } else {
    alert(restaurantProductsCategories.message)
    state.status = 'error'
  }
}

const RESTAURANT_PRODUCTS_CATEGORIES_DELETE = (state, restaurantProductsCategories) => {
  if (restaurantProductsCategories.code === 1) {
    state.restaurantProductsCategories = restaurantProductsCategories.data
    state.status = 'success'
    alert(restaurantProductsCategories.message)
  } else {
    alert(restaurantProductsCategories.message)
    state.status = 'error'
  }
}

export default {
  RESTAURANT_PRODUCTS_CATEGORIES_ALL,
  RESTAURANT_PRODUCTS_CATEGORIES_FORM,
  RESTAURANT_PRODUCTS_CATEGORIES_SHOW,
  RESTAURANT_PRODUCTS_CATEGORIES_CREATE,
  RESTAURANT_PRODUCTS_CATEGORIES_UPDATE,
  RESTAURANT_PRODUCTS_CATEGORIES_DELETE
}



// WEBPACK FOOTER //
// ./src/store/modules/restaurant/products/categories/mutations.js